import React, { useEffect, useState } from 'react';
import {
  Wrapper,
  Col1,
  Title,
  NewProductButton,
  Row,
  Field,
  Card,
  SubTitle,
  CustomLabel,
  CustomIcon,
  Action,
  LoadingWrapper,
  Span,
  DeleteButton,
  Strong,
  ModalWrapper,
  CustomAlert,
  Description,
  StatusBadge
} from './style';
import { useDispatch } from 'react-redux';
import { Icon, Input, Loading } from '../../../components/common';
import { SelectInput } from 'vqp-common';
import {
  fetchDestaques,
  removeDestaque,
  statusDestaque
} from '../../../redux/actions/destaques';
import useFetch from '../../../utils/useFetch';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import { Dialog, DialogContent } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useHistory } from 'react-router-dom';
import {
  STATUS_OPTIONS
} from '../constants';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: 'cod', numeric: false, disablePadding: false, label: 'Código' },
  { id: 'descricao', numeric: false, disablePadding: false, label: 'Descrição' },
  { id: 'ordem', numeric: true, disablePadding: false, label: 'Ordem' },
  { id: 'status', numeric: false, disablePadding: false, label: 'Status' },
  { id: 'actions', numeric: false, disablePadding: false, label: 'Ações' }
];

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.id !== 'actions' ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired
};

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  table: {
    minWidth: 750
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  }
}));

const LayoutSearchPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const { response, error, loading: fetchLoading } = useFetch(fetchDestaques);

  const [loading, setLoading] = useState(false);
  const [destaques, setDestaques] = useState([]);
  const [rows, setRows] = useState([]);
  const [filtered, setFiltered] = useState(null);
  const [code, setCode] = useState('');
  const [descricao, setDescricao] = useState('');
  const [ordemFilter, setOrdemFilter] = useState('');
  const [status, setStatus] = useState(0);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('cod');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedDestaque, setSelectedDestaque] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  useEffect(() => {
    if (response) {
      setDestaques(response);
      setRows(response);
    } else if (!fetchLoading) {
      setRows([]);
    }
  }, [response, fetchLoading]);

  const displayRows = filtered != null ? filtered : rows;

  const handleAdd = () => {
    history.push({ pathname: '/layout-cadastro' });
  };

  const handleEdit = (destaque) => {
    history.push({
      pathname: '/layout-cadastro',
      state: {
        id: destaque.id,
        imagemUrl: destaque.imagemUrl || ''
      }
    });
  };

  const handleClickSnackbar = (message) => {
    setSnackbarMessage(message);
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const handleFilter = () => {
    const result = destaques.filter((item) => {
      const filterCode =
        item.cod.toString().toLowerCase().indexOf(code.toLowerCase()) !== -1;
      const filterDescricao =
        (item.descricao || '').toLowerCase().indexOf(descricao.toLowerCase()) !== -1;
      const filterOrdem =
        !ordemFilter ||
        String(item.ordem != null ? item.ordem : '').indexOf(String(ordemFilter)) !== -1;

      let filterStatus = true;
      if (status === 1) filterStatus = item.statusId === 1;
      if (status === 2) filterStatus = item.statusId === 2;

      return filterCode && filterDescricao && filterOrdem && filterStatus;
    });

    setFiltered(result);
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const openDeleteModal = (destaque) => {
    setSelectedDestaque(destaque);
    setDeleteOpen(true);
  };

  const handleCloseDelete = () => {
    setDeleteOpen(false);
  };

  const refreshList = async () => {
    const response = await dispatch(fetchDestaques());
    if (response.success) {
      setFiltered(null);
      setDestaques(response.data);
      setRows(response.data);
    }
    setLoading(false);
  };

  const handleDelete = async () => {
    setLoading(true);
    const id = selectedDestaque ? selectedDestaque.id : null;
    const response = await dispatch(removeDestaque(id));
    if (response.success) {
      handleCloseDelete();
      handleClickSnackbar('Destaque removido com sucesso!');
      await refreshList();
    } else {
      setLoading(false);
    }
  };

  const handleStatus = async (id) => {
    setLoading(true);
    const response = await dispatch(statusDestaque(id));
    if (response.success) {
      handleClickSnackbar('Status do destaque alterado com sucesso!');
      await refreshList();
    } else {
      setLoading(false);
    }
  };

  const emptyRows =
    displayRows && displayRows.length > 0
      ? rowsPerPage - Math.min(rowsPerPage, displayRows.length - page * rowsPerPage)
      : 0;

  return (
    <Wrapper>
      <Col1>
        <Title>Consultar Destaques</Title>
        <NewProductButton className="primary create" onClick={handleAdd}>
          <Icon name="plus" /> Cadastrar Novo
        </NewProductButton>
        <Description>
          Consulte e gerencie abaixo todos os Destaques já cadastrados ou cadastre novos Destaques
          utilizando o botão ao lado.
        </Description>

        <SubTitle>Filtro de Busca</SubTitle>
        <Card>
          <Row>
            <Field>
              <CustomLabel>Código</CustomLabel>
              <Input id="code" name="code" type="text" value={code} onChange={setCode} />
            </Field>
            <Field>
              <CustomLabel>Descrição</CustomLabel>
              <Input
                id="descricao"
                name="descricao"
                type="text"
                value={descricao}
                onChange={setDescricao}
              />
            </Field>
            <Field>
              <CustomLabel>Ordem</CustomLabel>
              <Input
                id="ordem"
                name="ordem"
                type="number"
                value={ordemFilter}
                onChange={setOrdemFilter}
              />
            </Field>
            <Field>
              <CustomLabel>Status</CustomLabel>
              <SelectInput options={STATUS_OPTIONS} selected={status} onSelect={setStatus} />
            </Field>
          </Row>
          <NewProductButton className="primary" onClick={handleFilter}>
            <Icon name="search" /> Buscar
          </NewProductButton>
        </Card>

        <SubTitle>Destaques Existentes</SubTitle>

        {loading || fetchLoading ? (
          <LoadingWrapper>
            <Loading />
          </LoadingWrapper>
        ) : displayRows && displayRows.length > 0 ? (
          <Paper className={classes.paper}>
            <TableContainer>
              <Table className={classes.table} aria-labelledby="tableTitle" size="medium">
                <EnhancedTableHead
                  classes={classes}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {stableSort(displayRows, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow hover tabIndex={-1} key={row.id}>
                        <TableCell align="center">{row.cod}</TableCell>
                        <TableCell align="center">{row.descricao}</TableCell>
                        <TableCell align="center">{row.ordem != null ? row.ordem : '-'}</TableCell>
                        <TableCell align="center">
                          <StatusBadge active={row.status === 'Ativo'}>{row.status}</StatusBadge>
                        </TableCell>
                        <TableCell>
                          <Action>
                            <CustomIcon onClick={() => handleEdit(row)}>
                              <Icon
                                width="16px"
                                height="16px"
                                name="editCupom"
                                stroke="primary"
                                fill="primary"
                              />
                            </CustomIcon>
                            {row.status === 'Ativo' && (
                              <CustomIcon onClick={() => handleStatus(row.id)}>
                                <Icon
                                  width="16px"
                                  height="16px"
                                  name="inativeCupom"
                                  stroke="primary"
                                />
                              </CustomIcon>
                            )}
                            {row.status === 'Inativo' && (
                              <CustomIcon onClick={() => handleStatus(row.id)}>
                                <Icon
                                  width="16px"
                                  height="16px"
                                  name="activeCupom"
                                  stroke="primary"
                                />
                              </CustomIcon>
                            )}
                            <CustomIcon onClick={() => openDeleteModal(row)}>
                              <Icon
                                width="16px"
                                height="16px"
                                name="trashCupom"
                                stroke="primary"
                                fill="primary"
                              />
                            </CustomIcon>
                          </Action>
                        </TableCell>
                      </TableRow>
                    ))}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={5} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25]}
              component="div"
              count={displayRows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage="Qtde de itens"
            />
          </Paper>
        ) : (
          <CustomAlert>
            {error
              ? `Não foi possível carregar os destaques (${error})`
              : 'Nenhum destaque cadastrado'}
          </CustomAlert>
        )}

        <Dialog
          open={deleteOpen}
          onClose={handleCloseDelete}
          aria-labelledby="alert-dialog-title"
          fullWidth
          maxWidth="xs"
        >
          <DialogContent>
            <ModalWrapper>
              <Span>
                Deseja mesmo deletar o destaque{' '}
                <Strong>{selectedDestaque ? selectedDestaque.descricao : ''}</Strong>?
              </Span>
              <DeleteButton className="error center" onClick={handleDelete}>
                Deletar
              </DeleteButton>
            </ModalWrapper>
          </DialogContent>
        </Dialog>

        <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity="success">
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Col1>
    </Wrapper>
  );
};

export default LayoutSearchPage;
